//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ReferralQuestions',
  data () {
    return {
      showExpand: {
        1: true,
        2: false,
        3: false,
        4: false
      }
    }
  }
}
